import { extractProductSkus } from "./productGroupParser.js";
const processConversationData = (data, conversationId) => {
  if (!data || !data.messages || data.messages.length === 0) {
    return {
      messages: [],
      productMap: /* @__PURE__ */ new Map(),
      surveyMap: /* @__PURE__ */ new Map(),
      followUpQuestions: [],
      previewSearchQueries: [],
      previewQueryProducts: []
    };
  }
  const lastAssistantMessage = [...data.messages].reverse().find((m) => m.role === "assistant");
  const previewSearchQueries = Array.isArray(lastAssistantMessage == null ? void 0 : lastAssistantMessage.previewSearchQueries) ? lastAssistantMessage.previewSearchQueries : [];
  const previewQueryProducts = Array.isArray(lastAssistantMessage == null ? void 0 : lastAssistantMessage.previewQueryProducts) ? lastAssistantMessage.previewQueryProducts : [];
  const productMap = /* @__PURE__ */ new Map();
  if (data.products && Array.isArray(data.products)) {
    data.products.forEach((product) => {
      productMap.set(product.stacklineSku, product);
    });
  }
  const surveyMap = /* @__PURE__ */ new Map();
  if (data.surveys && Array.isArray(data.surveys)) {
    data.surveys.forEach((survey) => {
      surveyMap.set(survey.campaignId, survey);
    });
  }
  data.messages.forEach((msg) => {
    if (msg.surveys && Array.isArray(msg.surveys)) {
      msg.surveys.forEach((survey) => {
        if (!surveyMap.has(survey.campaignId)) {
          surveyMap.set(survey.campaignId, survey);
        }
      });
    }
  });
  let nextAssistantHasFeaturedProduct = null;
  const messages = data.messages.filter((msg) => msg.role === "user" || msg.role === "assistant").map((msg, index) => {
    const products = [];
    let messageContent = msg.content;
    if (typeof messageContent === "string" && messageContent.startsWith("{")) {
      try {
        const parsed = JSON.parse(messageContent);
        if (parsed.role === "user" && parsed.content) {
          messageContent = parsed.content;
        }
      } catch (e) {
      }
    }
    let featuredProduct = void 0;
    if (msg.role === "user") {
      const featuredProductRegex = /<product\s+featured="true"\s+stacklineSku="([^"]+)"(?:\s+question="([^"]+)")?\s*\/>/;
      const match = msg.content.match(featuredProductRegex);
      if (match) {
        const stacklineSku = match[1];
        const question = match[2] || "";
        const product = productMap.get(stacklineSku);
        messageContent = question;
        if (product) {
          nextAssistantHasFeaturedProduct = { product, question };
        }
      }
    }
    if (msg.role === "assistant") {
      const featuredProductRegex = /<product\s+featured="true"\s+stacklineSku="([^"]+)"(?:\s+question="([^"]+)")?\s*\/>/g;
      const featuredMatches = [...msg.content.matchAll(featuredProductRegex)];
      if (featuredMatches.length > 0) {
        const extractedFeaturedProducts = featuredMatches.map((match) => {
          const stacklineSku = match[1];
          const question = match[2] || "";
          const product = productMap.get(stacklineSku);
          if (product) {
            return { product, question };
          }
          return null;
        }).filter(Boolean);
        if (extractedFeaturedProducts.length > 0) {
          featuredProduct = extractedFeaturedProducts[0];
          nextAssistantHasFeaturedProduct = null;
        }
      } else {
        const productSkus = extractProductSkus(msg.content);
        productSkus.forEach((sku) => {
          const product = productMap.get(sku);
          if (product) {
            products.push(product);
          }
        });
        if (nextAssistantHasFeaturedProduct) {
          featuredProduct = nextAssistantHasFeaturedProduct;
          nextAssistantHasFeaturedProduct = null;
        }
      }
    }
    let imageUrl;
    let imageMimeType;
    if (msg.role === "user" && msg.imageUrl) {
      imageUrl = msg.imageUrl;
      imageMimeType = msg.imageMimeType;
    }
    return {
      role: msg.role,
      content: messageContent,
      timestamp: new Date(msg.timestamp),
      messageIndex: msg.messageIndex,
      // Include messageIndex for retry/feedback operations
      feedback: msg.feedback,
      // Include feedback state
      products,
      ...featuredProduct && { featuredProduct },
      // Attach preview data to individual assistant messages
      ...msg.role === "assistant" && msg.previewSearchQueries && { previewSearchQueries: msg.previewSearchQueries },
      ...msg.role === "assistant" && msg.previewQueryProducts && { previewQueryProducts: msg.previewQueryProducts },
      // Attach store locator to assistant messages
      ...msg.role === "assistant" && msg.storeLocator && { storeLocator: msg.storeLocator },
      // Attach login required to assistant messages (for unauthenticated purchase history requests)
      ...msg.role === "assistant" && msg.loginRequired && { loginRequired: msg.loginRequired },
      // Attach orders to assistant messages (for purchase history responses)
      ...msg.role === "assistant" && msg.orders && msg.orders.length > 0 && { orders: msg.orders },
      // Attach follow-up queries to assistant messages
      ...msg.role === "assistant" && msg.followUpQueries && { followUpQueries: msg.followUpQueries },
      // Attach devInfo for dev mode diagnostics on saved conversations
      ...msg.role === "assistant" && msg.devInfo && { devInfo: msg.devInfo },
      // Attach image URL for user messages (from S3)
      ...imageUrl && { imageUrl, imageMimeType }
    };
  });
  return {
    messages,
    productMap,
    surveyMap,
    followUpQuestions: data.followUpQuestions || [],
    previewSearchQueries,
    previewQueryProducts
  };
};
export {
  processConversationData
};
//# sourceMappingURL=conversationProcessor.js.map
